import { ShieldCheck, Handshake, FileText, Compass } from "lucide-react";
import { Reveal, SectionTag } from "./Reveal";

const ITEMS = [
  {
    icon: ShieldCheck,
    title: "Reliable Supply Partners",
    text: "Ajemi works with selected suppliers based on customer and transaction requirements.",
  },
  {
    icon: Handshake,
    title: "Procurement Support",
    text: "You have a procurement partner — instead of navigating the market alone.",
  },
  {
    icon: FileText,
    title: "Transparent Process",
    text: "Clear requirements, quotations, documentation and transaction steps.",
  },
  {
    icon: Compass,
    title: "Professional Coordination",
    text: "Ajemi helps coordinate procurement and delivery requirements, end to end.",
  },
];

export default function TrustSection() {
  return (
    <section id="trust" data-testid="trust-section" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <SectionTag number="14" label="Trust" />
          <h2 className="font-outfit text-3xl md:text-5xl font-extralight tracking-tight text-white">
            Built around <span className="text-gold">trust.</span>
          </h2>
        </Reveal>
        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {ITEMS.map((item, i) => (
            <Reveal key={item.title} delay={0.07 * i}>
              <div
                data-testid={`trust-card-${item.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="group h-full glass-panel rounded-2xl p-8 hover:border-gold/30 transition-all duration-500 hover:-translate-y-1"
              >
                <div className="w-12 h-12 rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center group-hover:bg-gold/20 transition-colors duration-500">
                  <item.icon className="w-5 h-5 text-gold" strokeWidth={1.5} />
                </div>
                <h3 className="font-outfit text-xl font-light text-white mt-7">{item.title}</h3>
                <p className="text-sm text-white/50 mt-3 leading-relaxed">{item.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
